var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location_shipment" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "shipping" } }, [
        _vm._v(
          "\n            " + _vm._s(_vm.__t("SHIPPING_TYPE")) + "\n        "
        ),
      ]),
      _vm._v(" "),
      _vm.shippings.length > 0
        ? _c(
            "div",
            {},
            [
              _c("v-select", {
                staticClass: "imc_reasons",
                attrs: {
                  id: "shipping",
                  label: "title",
                  reduce: function (shipping) {
                    return shipping.id
                  },
                  options: this.shippings,
                  filterable: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "d-center" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(option.title) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  706905049
                ),
                model: {
                  value: _vm.location.shipping_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.location, "shipping_id", $$v)
                  },
                  expression: "location.shipping_id",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "shipping_delivery" } },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm.__t("SHIPPING_TYPE_DELIVERY")) +
              "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.shippings.length > 0
        ? _c(
            "div",
            {},
            [
              _c("v-select", {
                staticClass: "imc_reasons",
                attrs: {
                  id: "shipping_delivery",
                  label: "title",
                  reduce: function (shipping) {
                    return shipping.id
                  },
                  options: this.shippings,
                  filterable: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "d-center" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(option.title) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  706905049
                ),
                model: {
                  value: _vm.location.shipping_delivery_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.location, "shipping_delivery_id", $$v)
                  },
                  expression: "location.shipping_delivery_id",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }